module.exports = __webpack_public_path__ + "media/images/emoticons/cake-8aec37a54c6a2dca10781a7e26fda854.gif";